module.exports = __webpack_public_path__ + "static/media/sad-calculator.2adf940e.png";